import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { Autocomplete, createFilterOptions } from '@mui/material';
import TextField from '@mui/material/TextField';
import { red } from '@mui/material/colors';
import LeadStore from '../../store/LeadStore';

const filter = createFilterOptions();

export const SelectCreateWorkflowStatus = observer(
  ({ label, id, handleSelectedWorkflowStatus, selectedWorkflowStatusList, dataList }) => {
    const [selectedWorkflowStatus, setSelectedWorkflowStatus] = useState(null);
    const [data, setData] = useState([]);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
      handleSelectedWorkflowStatus(selectedWorkflowStatus);
      setIsError(selectedWorkflowStatus === null || selectedWorkflowStatus === undefined);
    }, [selectedWorkflowStatus]);

    useEffect(() => {
      setData(dataList);
      setIsError(false);
    }, [dataList]);

    useEffect(() => {
      document.querySelector(`#${getId()} fieldset`).style.borderColor = isError ? '#ff0000' : 'rgba(0, 0, 0, 0.23)';
      document.querySelector(`#${getId()} label`).style.color = isError ? '#ff0000' : 'rgba(0, 0, 0, 0.6)';
    }, [isError]);

    const getId = () => {
      return `select-workflowStatus-autocomplete-${id}`;
    };

    return (
      <>
        <div id={getId()}>
          <Autocomplete
            value={selectedWorkflowStatus}
            size="small"
            disableClearable
            onChange={(event, newValue) => {
              if (typeof newValue === 'string') {
                setSelectedWorkflowStatus({
                  name: newValue,
                });
              } else if (newValue && newValue.inputValue) {
                // Create a new value from the user input
                setSelectedWorkflowStatus({
                  name: newValue.inputValue,
                });
              } else {
                setSelectedWorkflowStatus(newValue);
              }
            }}
            filterOptions={(options, params) => {
              const filtered = filter(options, params);

              const { inputValue } = params;
              // Suggest the creation of a new value
              const isExisting = options.some((option) => inputValue === option.name);
              if (inputValue !== '' && !isExisting) {
                filtered.push({
                  inputValue,
                  name: `Add "${inputValue}" WorkflowStatus`,
                });
              }

              return filtered;
            }}
            selectOnFocus
            handleHomeEndKeys
            options={data}
            getOptionLabel={(option) => {
              // Value selected with enter, right from the input
              if (typeof option === 'string') {
                return option;
              }
              // Add "xxx" option created dynamically
              if (option.inputValue) {
                return option.inputValue;
              }
              // Regular option
              return option.name;
            }}
            getOptionDisabled={(option) => {
              if (option.id === null || option.id === undefined) {
                return false;
              }
              if (selectedWorkflowStatusList.length) {
                return (
                  selectedWorkflowStatusList.findIndex((item) => item.id?.toString() === option.id?.toString()) !== -1
                );
              } else {
                return false;
              }
            }}
            renderOption={(props, option) => <li {...props}>{option.name}</li>}
            freeSolo
            required
            renderInput={(params) => <TextField {...params} label={label} />}
          />
        </div>
      </>
    );
  }
);
